// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__19QG6","inner":"Form_inner__3FyUY","range":"Form_range__lzKM5","name":"Form_name__1kvHi","actions":"Form_actions__3v1_P"};